const pageNameKey = "foundAllNodesPillBox";

export const foundAllNodesPillBoxEn = {
  [pageNameKey]: {
    done: "Done",
    indicatorIconAltText: "Indicator Icon",
  },
};

export const foundAllNodesPillBoxPtBr = {
  [pageNameKey]: {
    done: "Concluído",
    indicatorIconAltText: "Ícone indicador",
  },
};

export const foundAllNodesPillBoxDe = {
  [pageNameKey]: {
    done: "Fertig",
    indicatorIconAltText: "Indikator Icon",
  },
};

export const foundAllNodesPillBoxZhHans = {
  [pageNameKey]: {
    done: "完成",
    indicatorIconAltText: "指示器图标",
  },
};

export const foundAllNodesPillBoxIt = {
  [pageNameKey]: {
    done: "Fatto",
    indicatorIconAltText: "Icona indicatore",
  },
};

export const foundAllNodesPillBoxEs = {
  [pageNameKey]: {
    done: "Hecho",
    indicatorIconAltText: "Icono indicador",
  },
};

export const foundAllNodesPillBoxNl = {
  [pageNameKey]: {
    done: "Klaar",
    indicatorIconAltText: "Indicatorpictogram",
  },
};

export const foundAllNodesPillBoxTr = {
  [pageNameKey]: {
    done: "Tamamlamak",
    indicatorIconAltText: "Gösterge Simgesi",
  },
};
